import { Form, Formik } from 'formik';
import FormikControl from '_metronic/formikHelper/FormikControl';

const Filter = ({handleSubmit}:{ handleSubmit:(fromDate: string | undefined, toDate: string | undefined)=> void}) => {
    function formatDateLocal(dateStr: string) {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const onSubmit = async (values: { fromDate: string, toDate: string}, { setSubmitting, resetForm }: any) => {
        handleSubmit(values.fromDate ? formatDateLocal(values.fromDate) : undefined ,values.toDate ? formatDateLocal(values.toDate) : undefined)
    };

    return (
        <div className='card pt-4 ps-4 mb-4'>
        <Formik
            initialValues={{fromDate: '', toDate: ''}}
            // validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {(formik) => {
                return (
                    <Form className='form d-flex w-100 gap-5 h-60px' noValidate>
                        <p className='mt-3'>Filter by:</p>
                        <p className='mt-3'>From</p>
                        <FormikControl
                            control='date'
                            name='fromDate'
                            label=''
                            type='fromDate'
                            autoComplete='off'
                        />
                        <p className='mt-3'>To</p>
                        <FormikControl
                            control='date'
                            name='toDate'
                            label=''
                            type='toDate'
                            autoComplete='off'
                        />
                        <div className='text-center'>
                            <button
                                type='submit'
                                className='btn btn-primary'
                                disabled={formik.isSubmitting || !formik.dirty}
                            >
                                filter
                            </button>
                        </div>
                    </Form>
                );
            }}
        </Formik>
    </div>);
};

export default Filter;
